import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ArticleCardComponent } from '../article-card/article-card.component';
import { Article } from './models/articles.model';

@Component({
    selector: 'nw-articles-block',
    imports: [ArticleCardComponent],
    templateUrl: './articles-block.component.html',
    styleUrl: './articles-block.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlesBlockComponent {
    @Input() title?: string;
    @Input() articles!: Article[];
}
